import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Tooltip,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TablePagination,
} from "@mui/material";
import deletelogo from "../../../../Utils/Logos/deleteuser.png";
import editlogo from "../../../../Utils/Logos/edit.png";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllUsers,
  SearchUser,
} from "../../../../Redux/Slices/Users/User.action";
import { debounce } from "lodash";
import TitleText from "../../../../Components/TitleText";

import ActionButton from "../../../../Components/Popups/PopupComponent/ActionButton";
import AddUpdateDiscount from "./AddUpdateDiscount";
import { GetPriceGrouprange } from "../../../../Redux/Slices/Sessions/Session.action";
import DeleteRange from "../../../../Components/Popups/DeleteRange";
const columns = [
  { id: "#", label: "#" },

  { id: "Range", label: " Price Range" },
  { id: "Discount", label: "Discount" },
  { id: "Action", label: "Action" },
];

const Discount = () => {
  let data = useSelector((store) => store?.Sessions);
  let dispatch = useDispatch();

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  //   dispatch(
  //     GetPriceGrouprange({
  //       count: newPage * rowsPerPage,
  //       // row_count: rowsPerPage,
  //     })
  //   );
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   const newRowsPerPage = parseInt(event.target.value, 10);
  //   setRowsPerPage(newRowsPerPage);
  //   setPage(0);
  //   dispatch(GetPriceGrouprange({ count: 0,  }));
  // };

  let Rowdata = data?.PriceRange?.map((data, i) => ({
    rowid: i + 1,
    ...data,
  }));

  let [iseditpopup, setiseditpopup] = useState(false);
  let [editfiledata, seteditfiledata] = useState(null);

  let openeditpopup = (data) => {
    seteditfiledata(data);
    setiseditpopup(true);
  };

  let closeeditpopup = () => {
    setiseditpopup(false);
  };

  // --------- Delete Conformation Popup ------------

  let [isdelete, setisdelete] = useState(false);
  let [deleteselected, setisdeleteresource] = useState(null);

  let openresorcedelete = (data) => {
    setisdelete(true);
    setisdeleteresource(data);
  };

  let closedelete = () => {
    setisdelete(false);
    setisdeleteresource(null);
  };

  const addNewDiscount = () => {
    setiseditpopup(true);
    seteditfiledata(null);
  };

  useEffect(() => {
    dispatch(GetPriceGrouprange());
  }, [isdelete, iseditpopup]);
  return (
    <>
      {iseditpopup ? (
        <AddUpdateDiscount
          modalcontrols={{ iseditpopup, closeeditpopup }}
          editeData={editfiledata ? editfiledata : null}
          rangedata={Rowdata}
        />
      ) : (
        ""
      )}
      {isdelete && deleteselected !== null ? (
        <DeleteRange
          modalcontrols={{ isdelete, closedelete, deleteselected }}
        />
      ) : (
        ""
      )}
      <TitleText title={"Discount"} />

      <Box
        sx={{
          boxShadow: "none",
          outline: "none",
          mb: "20px",
          border: "none",
          mt: "5px",
          width: "100%",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
        >
          <Box
            sx={{ width: "20%", display: "flex", justifyContent: "flex-end" }}
          >
            <ActionButton onclick={addNewDiscount} title={"Add Discount"} />
          </Box>
        </Box>
        <Paper style={{ width: "100%", overflow: "hidden" }}>
          <TableContainer style={{ maxHeight: "78vh" }}>
            <Table stickyHeader sx={{}}>
              <TableHead>
                <TableRow>
                  {columns?.map((column) => (
                    <TableCell
                      key={column.id}
                      sx={{
                        textAlign: "center",
                        fontSize: "15px",
                        lineHeight: "120%",
                        fontFamily: "Montserrat",
                        fontWeight: "600",
                        background: "#F68582",
                        color: "#fff",
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Rowdata?.length < 1 ? (
                  <Box sx={{ textAlign: "center", padding: "10px", m: "10px" }}>
                    {data?.loading ? "Getting Data" : " No Data"}
                  </Box>
                ) : (
                  Rowdata?.map((row, i) => (
                    <TableRow key={row.id} sx={{ textAlign: "center" }}>
                      <TableCell sx={{ textAlign: "center" }}>
                        {row?.rowid}
                      </TableCell>

                      <TableCell sx={{ textAlign: "center" }}>
                        {" "}
                        {Rowdata?.length == i + 1 ? `${row?.min_amount} -- ${row?.max_amount} +    ` : <span>{row?.min_amount} -- {row?.max_amount}</span>}
                  
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {" "}
                        {row?.discount}%
                      </TableCell>

                      <TableCell
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <Box
                          sx={{
                            height: "50px",
                            display: "flex",
                            gap: "20px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                         
                            <img
                              onClick={() => openresorcedelete(row)}
                              style={{
                                width: "30px",
                                height: "30px",
                                cursor: "pointer",
                              }}
                              src={deletelogo}
                              alt=""
                            />
                        

                          <img
                            onClick={() => openeditpopup(row)}
                            style={{
                              width: "30px",
                              height: "30px",
                              cursor: "pointer",
                            }}
                            src={editlogo}
                            alt=""
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        {/* <Box>
          <TablePagination
            sx={{ mb: "-20px" }}
            component="div"
            count={data?.UsersData?.count || 0}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPage={rowsPerPage}
          />
        </Box> */}
      </Box>
    </>
  );
};

export default Discount;
